"use client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useT } from "providers/I18nProvider";

/**
 * Dải cuộn ngang dùng chung cho trang chủ (Ưu đãi trải nghiệm, Săn giờ đẹp).
 * Mobile: vuốt + snap như cũ. Desktop: thêm nút ‹ › (chuột thường không cuộn ngang được),
 * tự ẩn nút khi đã chạm đầu/cuối dải.
 */
const Rail: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className = "",
  children,
}) => {
  const t = useT();
  const ref = useRef<HTMLDivElement>(null);
  const [edge, setEdge] = useState({ start: true, end: true });

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setEdge({
      start: el.scrollLeft <= 4,
      end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 4,
    });
  }, []);

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [update]);

  // Mỗi lần bấm cuộn ~85% bề rộng để luôn lộ lại 1 phần thẻ cũ (giữ ngữ cảnh)
  const scrollBy = (dir: 1 | -1) =>
    ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.85, behavior: "smooth" });

  const btn =
    "hidden md:flex absolute top-1/2 -translate-y-1/2 z-10 w-11 h-11 items-center justify-center rounded-full bg-white text-black01 shadow-lg ring-1 ring-black/5 transition hover:scale-105 hover:text-primary-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary";

  return (
    <div className="relative">
      <div
        ref={ref}
        className={`flex items-stretch overflow-x-scroll scrollbar-hide snap-x snap-mandatory scroll-px-4 md:snap-none [&>*]:snap-start pt-2 -mt-2 pb-3 ${className}`}
      >
        {children}
      </div>
      {!edge.start && (
        <button type="button" aria-label={t("home.railPrev")} onClick={() => scrollBy(-1)} className={`${btn} left-1`}>
          <ChevronLeft className="w-5 h-5" />
        </button>
      )}
      {!edge.end && (
        <button type="button" aria-label={t("home.railNext")} onClick={() => scrollBy(1)} className={`${btn} right-1`}>
          <ChevronRight className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default Rail;
